import { Footer, Header, Skills, Work } from './container';
import Navbar from './components/Navbar/Navbar';
import './App.scss';
import Education from './container/Education/Education';

const App = () => (
  <div className="app">
    <Navbar />
    <Header />
    <Work />
    <Skills />
    <Education />
    <Footer />
  </div>
);

export default App;
